export enum NewsType {
    All = 'all',
    Game = 'game',
    Promotion = 'promotion',
}
